// Account Receivable Payments Mutations

export const updatePaymentsList = (state, payload) => {
  state.paymentsList = payload
}

export const updatePaymentInfo = (state, payload) => {
  state.paymentInfo = payload
}
